export default class EventEmitter {
    constructor() {
    }
    static subscribe(name, callback) {
        const [eventName, groupName = "default"] = name.split(".", 2);
        if (!EventEmitter.subscribers[eventName])
            EventEmitter.subscribers[eventName] = {};
        EventEmitter.subscribers[eventName][groupName] = {
            suspended: false,
            callback
        };
    }
    static unsubscribe(name) {
        this.execute(name, (subscriber, eventName, group) => {
            delete EventEmitter.subscribers[eventName][group];
        });
    }
    static unmiddleware(name, type) {
        if (!type) {
            delete this.middlewares[name];
            return;
        }
        delete this.middlewares[name][type];
    }
    static suspension(name) {
        this.execute(name, (subscriber, eventName, group) => {
            EventEmitter.subscribers[eventName][group] = Object.assign(Object.assign({}, subscriber), { suspended: true });
        });
    }
    static unsuspension(name) {
        this.execute(name, (subscriber, eventName, group) => {
            EventEmitter.subscribers[eventName][group] = Object.assign(Object.assign({}, subscriber), { suspended: false });
        });
    }
    static emit(name, data) {
        if (this.middlewares[name] && this.middlewares[name]["pre"]) {
            this.middlewares[name]["pre"](data);
        }
        this.execute(name, (subscriber) => {
            if (!subscriber.suspended)
                subscriber.callback(data);
        });
        if (this.middlewares[name] && this.middlewares[name]["post"]) {
            this.middlewares[name]["post"](data);
        }
    }
    static middleware(name, type, callback) {
        this.middlewares[name] = Object.assign(Object.assign({}, this.middlewares[name]), { [`${type}`]: callback });
    }
    static execute(name, callback) {
        const [eventName, groupName] = name.split(".", 2);
        let subscribers = Object.assign({}, EventEmitter.subscribers[eventName]);
        if (groupName)
            subscribers = { [`${groupName}`]: subscribers[groupName] };
        // if (subscribers['default'] && subscribers['default'].suspended) {
        //     callback(subscribers['default'], eventName, 'default')
        //     delete subscribers['default']
        // }
        for (const group in subscribers) {
            if (!subscribers[group])
                continue;
            callback(subscribers[group], eventName, group);
        }
    }
}
EventEmitter.subscribers = {};
EventEmitter.middlewares = {};
